<template>
  <button
    v-if="shouldShowInstallButton()"
    @click="handleInstallClick"
    class="btn btn-sm btn-primary d-flex align-items-center pwa-btn pwa-install-container"
    :title="installButtonTitle"
  >
    <i class="fas fa-download pwa-icon"></i>
    <span class="pwa-text">Instalar App</span>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import usePWAInstall from '@/composables/usePWAInstall';
import useModals from '@/components/Modals/useModals';
import { EModal } from '@/enums';

const { platform, shouldShowInstallButton, showInstallPrompt } = usePWAInstall();
const { toggleModal } = useModals();

const installButtonTitle = computed(() => {
  if (platform.value === 'ios') {
    return 'Adicionar à tela inicial';
  }
  return 'Instalar aplicativo';
});

const handleInstallClick = async () => {
  // Para iOS, mostra o modal com instruções
  if (platform.value === 'ios') {
    toggleModal(EModal.pwa_install);
    return;
  }

  // Para Android/Desktop, mostra o prompt nativo
  const installed = await showInstallPrompt();

  if (installed) {
    console.log('📱 PWA: App will be installed');
  }
};
</script>

<style scoped>
.pwa-install-container {
  margin-right: 0.75rem;
}

.pwa-btn {
  white-space: nowrap;
}

.pwa-btn:hover {
  background-color: white !important;
  color: var(--bs-primary) !important;
  border-color: var(--bs-primary) !important;
}

.pwa-icon {
  margin-right: 0.5rem;
}

@media (max-width: 768px) {
  .pwa-install-container {
    margin-right: 0.5rem;
  }

  .pwa-btn {
    padding: 0.25rem 0.4rem !important;
    font-size: 0.75rem;
    white-space: nowrap;
  }

  .pwa-icon {
    margin-right: 0.25rem;
    font-size: 0.7rem;
  }

  .pwa-text {
    font-size: 0.75rem;
  }
}
</style>
